export default __webpack_public_path__ + "static/media/8.d9ebc0eb.png";